export class GameCamera {
  constructor(scene, map) {
    this._scene = scene;
    this._camera = scene.cameras.main;
    this._mapWidth = map.mapWidth;
    this._mapHeight = map.mapHeight;
    this._zoneLocked = false;
    this._camOffset = map.mapHeight - 720;
    this._mapExit = map.getMapData().exit;
    this._camera.setBounds(0, this._camOffset, this._mapExit, map.mapHeight - this._camOffset);
  }

  get zoneLocked() {
    return this._zoneLocked;
  }

  set minLeft(value) {
    this._minLeft = value;
    this.updateCameraBounds();
  }

  update(delta) {
    this._viewport = new Phaser.Geom.Rectangle(
      this._camera.scrollX + this._scene.game.viewportController.left,
      this._camera.scrollY + this._scene.game.viewportController.top,
      this._scene.game.viewportController.width,
      this._scene.game.viewportController.height
    );
    return this._viewport;
  }

  // =============================================================================================
  // FOLLOW CHARACTER
  // =============================================================================================

  followCharacter(character) {
    this._followCharacter = character;
    this._camera.startFollow(this._followCharacter, true, 0.1, 1, -300, 200);
  }

  stopFollowing() {
    this._followCharacter = null;
    this._camera.stopFollow();
  }

  // =============================================================================================
  // VIEWPORT
  // =============================================================================================

  get viewport() {
    return this._viewport;
  }

  isInViewport({ x, y }) {
    return this._viewport.contains(x, y);
  }

  // =============================================================================================
  // XONE LOCKING
  // =============================================================================================

  lockToZone(zone) {
    const viewport = this._scene.game.viewportController.viewport;
    const ox = (1680 - viewport.width) * 0.5;

    const x = Math.min(zone.x, this.viewport.x);
    const y = this._camOffset;
    const width = Math.max(zone.width, this.viewport.width);
    const height = this._mapHeight - this._camOffset;
    this._camera.setBounds(x - ox, y, width + ox * 2, height);
    this._zoneLocked = true;
  }

  releaseZoneLock() {
    this._zoneLocked = false;
    // this._camera.setBounds(0, this._camOffset, this._mapExit, this._mapHeight - this._camOffset);
    this.updateCameraBounds();
  }

  updateCameraBounds() {
    if (this._zoneLocked) {
      return;
    } else {
      const viewport = this._scene.game.viewportController.viewport;
      const ox = (1680 - viewport.width) * 0.5;
      const oy = (720 - viewport.height) * 0.5;

      this._camera.setBounds(
        -ox,
        this._camOffset,
        this._mapExit + ox * 2,
        this._mapHeight - this._camOffset
      );
    }
  }
}
